import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@material-ui/core";
import { IAMAction } from "../../actions";

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        height: theme.spacing(50)
    },
}));

const LockedUser = (props) => {
    const { profile } = props
    const classes = useStyles()
    const dispatch = useDispatch()

    return (
        <React.Fragment>
            <Dialog open={profile.status === "USER_ACCOUNT_LOCKED" || profile.islocked === 3} fullWidth maxWidth='md'>
                <DialogTitle>
                    <Typography variant="h2" color="textSecondary">Account Locked</Typography>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <Typography variant="h4" color="textSecondary">Your ESP account is locked.</Typography>
                    <Typography variant="h4" color="textSecondary">Reach out to your manager to get your account unlocked.</Typography>
                    <br></br><br></br>
                    <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={1}>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Username:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.username}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Name:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.fname + " " + profile.lname}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Email:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.email}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Company:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.company}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Manager Name:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.manager_name}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Manager Email:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.manager_email}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
                                <Grid item style={{ minWidth: 150 }}><Typography variant="h5" color="textSecondary">Registration Date:</Typography></Grid>
                                <Grid item style={{ width: 300 }}><Typography variant="h5" color="textSecondary">{profile.registration_date}</Typography></Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={() => IAMAction.logout(dispatch)}>Logout</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default LockedUser
